import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
// Keep this order: Tailwind utilities must load after element-ui and the global CSS,
// so a utility wins over a single-class element-ui rule without an important (!) marker.
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/index.css';
import './assets/css/tailwind.css';
import * as filters from './utils/filter';
import './middleware'
import enterSubmit from './directives/enterSubmit';

import CloudIcon from './components/common/CloudIcon.vue';
import DistroIcon from './components/common/DistroIcon.vue';
import Clipboard from 'v-clipboard';
import VueQr from 'vue-qr'
import JsonExcel from 'vue-json-excel';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.use(Clipboard);
Vue.use(VueQr)

import i18n  from './utils/i18n'
// import viLocale from 'element-ui/lib/locale/lang/vi';

Vue.component('CloudIcon', CloudIcon)
Vue.component('DistroIcon', DistroIcon)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component('downloadExcel', JsonExcel);
Vue.component('VueSlider', VueSlider);
Vue.directive('enter-submit', enterSubmit);
Vue.config.productionTip = false

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
